import { useState } from "react";
import {
  IconButton,
  IconButtonSize,
  IconButtonVariant
} from "shared/components";
import {
  LabelPosition,
  Switch,
  SwitchSize
} from "shared/components/forms/Switch";
import { IconSvgElement } from "@hugeicons/react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from "shared/components/Popover";
import { ColumnVisibilityItem } from "providers/Auth";

export const VisibilityPanel = ({
  heading,
  items,
  onToggle,
  triggerIcon,
  triggerLabel,
  disabled
}: {
  heading: string;
  items: ColumnVisibilityItem[];
  onToggle: (id: string, checked: boolean) => void;
  triggerIcon: IconSvgElement;
  triggerLabel?: string;
  disabled?: boolean;
}) => {
  const [open, setOpen] = useState(false);

  return (
    <Popover placement="bottom-end" open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <IconButton
          size={IconButtonSize.SM}
          variant={IconButtonVariant.BASE}
          HugeIcon={triggerIcon}
          aria-label={triggerLabel}
          disabled={disabled}
          onClick={() => setOpen((prev) => !prev)}
        />
      </PopoverTrigger>

      <PopoverContent className="z-20 max-w-[300px] w-full rounded-lg border border-alpha-100 bg-content-1000-inverted px-3 py-5 shadow-xl">
        <h3 className="px-3 pb-4 text-sm font-medium text-content-300">
          {heading}
        </h3>
        <div>
          {items.map((item) => (
            <div key={item.id} className="px-3 py-2.5">
              <Switch
                label={item.label}
                size={SwitchSize.SM}
                checked={item.checked}
                disabled={item.always_on}
                onChange={() => onToggle(item.id, !item.checked)}
                wrapperClassName="justify-between w-full"
                position={LabelPosition.Left}
              />
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
